// @flow
import Properties from "../../../Properties";
import type { DispatchType, StateType } from "../../global/types/redux";
import {
  getInit,
  postInit,
  graphQLInit,
  putInit,
  deleteInit,
  postBody,
  putBody
} from "../../global/types/constants";
import {
  LIST_PEOPLE,
  GET_FACE,
  SET_UPDATING,
  SET_SEARCH_QUERY,
  SET_SHOWMORE_STATUS,
  SET_FACE,
  SET_EMPTY_ENROLMENTS,
  SET_NAME,
  SET_TAGS,
  DELETE_PERSON,
  ADD_PERSON,
  SET_PEOPLE_FORM_ERROR
} from "../../global/actions/actionNames";

import { PersonType } from "../types/UserType";
import { PersonInputModel } from "../types/InputModels";
import { handleResponse } from "./handleResponse";

const root = Properties.api_root;
const face_root = Properties.facedb_root;

export function fetchPeople(
  query: string = "",
  isSearch: boolean = false,
  rate: number = 30,
  person_id: string = "",
  doneCall: Function | null = null,
  isAppend: boolean = false
): DispatchType {
  let formData = new FormData();
  formData.append("rate", String(rate));
  person_id && formData.append("person_id", person_id);
  formData.append("name_filter", query);

  return (dispatch: DispatchType) => {
    dispatch({
      type: SET_UPDATING,
      status: true,
      sender: isSearch ? "searching" : "fetchingPeople"
    });
    fetch(face_root + "/api/v2/people/search", postInit(formData))
      .then(handleResponse)
      .then((json: *) => {
        dispatch({
          type: LIST_PEOPLE,
          people: json.people,
          sendTime: Date.now(),
          isAppend: isAppend
        });
        dispatch({ type: SET_SEARCH_QUERY, query: query });
        dispatch({
          type: SET_SHOWMORE_STATUS,
          status: json.people.length === rate
        });
        for (let i = 0; i < json.people.length; i++) {
          dispatch(getFaceFromUid(json.people[i].uid));
        }
        dispatch({
          type: SET_UPDATING,
          status: false,
          sender: isSearch ? "searching" : "fetchingPeople"
        });

        doneCall && doneCall();
      })
      .catch(() => {
        dispatch({
          type: SET_UPDATING,
          status: false,
          sender: isSearch ? "searching" : "fetchingPeople"
        });
      });
  };
}

export function getFaceFromUid(uid: string): DispatchType {
  return (dispatch: DispatchType) => {
    dispatch({ type: SET_UPDATING, status: true, sender: "fetchingPeople" });
    fetch(face_root + "/api/v2/people/" + uid + "/cover", getInit)
      .then(function (response: Response): * {
        if (response.status === 200) {
          return response.blob();
        } else {
          return Promise.reject();
        }
      })
      .then(function (blob: Blob) {
        let objectURL = URL.createObjectURL(blob);
        dispatch({ type: GET_FACE, face: objectURL, uid: uid });
        dispatch({
          type: SET_UPDATING,
          status: false,
          sender: "fetchingPeople"
        });
      })
      .catch(() => {
        dispatch({
          type: SET_UPDATING,
          status: false,
          sender: "fetchingPeople"
        });
      });
  };
}

export function getEnrolments(personUid: string): DispatchType {
  return (dispatch: DispatchType) => {
    fetch(face_root + "/api/v2/people/" + personUid + "/enrolments", getInit)
      .then((res: Response): * => res.json())
      .then((res: *) => {
        if (res.length === 0) {
          dispatch({ type: SET_EMPTY_ENROLMENTS, personUid: personUid });
        } else {
          dispatch(getFaces(res, personUid));
        }
      })
      .catch((err: *) => {
        console.error(err);
      });
  };
}

export function getFaces(
  enrolments: Array<*>,
  personUid: string
): DispatchType {
  return (dispatch: DispatchType) => {
    for (var i = 0; i < enrolments.length; i++) {
      for (var j = 0; j < enrolments[i].faces.length; j++) {
        let faceId = enrolments[i].faces[j].faceId;
        dispatch(getFace(faceId, enrolments[i].enrolmentId, personUid));
      }
    }
  };
}

export function getFace(
  faceId: string,
  enrolmentId: string,
  personUid: string
): DispatchType {
  return (dispatch: DispatchType) => {
    fetch(face_root + "/api/v2/enrolments/face/" + faceId, getInit)
      .then(function (response: Response): * {
        return response.blob();
      })
      .then(function (myBlob: Blob) {
        let objectURL = URL.createObjectURL(myBlob);
        dispatch({
          type: SET_FACE,
          enrolmentId: enrolmentId,
          faceId: faceId,
          faceData: objectURL,
          personUid: personUid
        });
      })
      .catch((error: *) => {
        console.error(error);
      });
  };
}

export function enrolMultiple(
  person: PersonType,
  isUpdate?: boolean = false,
  callBack?: Function
): DispatchType {
  if (person.enrolments && person.enrolments.length > 0) {
    let formData = new FormData();
    let enrolments = [];
    for (var i = 0; i < person.enrolments.length; i++) {
      enrolments.push({
        token: person.enrolments[i].imgToken,
        eyes: person.enrolments[i].imgEyes
      });
    }
    formData.append("image_tokens", JSON.stringify(enrolments));

    return (dispatch: DispatchType) => {
      dispatch({
        type: SET_UPDATING,
        status: true,
        sender: isUpdate ? "editing" : "creating"
      });
      fetch(
        face_root + "/api/v2/people/" + person.uid + "/enrolments",
        postInit(formData)
      )
        .then((res: Response): Promise<JSON> => {
          if (res.status === 200 || res.status === 409) {
            return res.json();
          } else {
            return Promise.reject();
          }
        })
        .then(function (json: JSON): Function {
          if (json.errors) {
            dispatch(setPeopleFormError(json.errors.image));
          } else {
            let enrolment_uid = json.image_tokens[0].enrolment_uid;
            callBack && callBack(enrolment_uid);
          }
          dispatch({
            type: SET_UPDATING,
            status: false,
            sender: isUpdate ? "editing" : "creating"
          });
        })
        .catch((reason: *) => {
          dispatch({
            type: SET_UPDATING,
            status: false,
            sender: isUpdate ? "editing" : "creating"
          });
          console.error(reason);
        });
    };
  } else {
    return (dispatch: DispatchType) => {
      console.log("no enrolment added");
    };
  }
}

export function deleteMultipleEnrolments(
  personUid: string,
  enrolments: Array<*>,
  isUpdate?: boolean = false
): DispatchType {
  return (dispatch: DispatchType) => {
    for (var i = 0; i < enrolments.length; i++) {
      dispatch(
        deleteEnrolments(personUid, enrolments[i].enrolmentId, isUpdate)
      );
    }

    if (enrolments.length > 0) {
      setTimeout(function () {
        dispatch(getFaceFromUid(personUid));
      }, 500);
    }
  };
}

export function deleteEnrolments(
  personUid: string,
  enrolment_uid: string,
  isUpdate?: boolean = false
): DispatchType {
  return (dispatch: DispatchType) => {
    dispatch({
      type: SET_UPDATING,
      status: true,
      sender: isUpdate ? "editing" : "creating"
    });
    fetch(
      face_root +
        "/api/v2/enrolments/" +
        enrolment_uid +
        "?person_uuid=" +
        personUid,
      deleteInit()
    )
      .then((res: Response): Promise<JSON> => res.json())
      .then((json: JSON): Function => {
        dispatch({
          type: SET_UPDATING,
          status: false,
          sender: isUpdate ? "editing" : "creating"
        });
      })
      .catch((error: *) => {
        dispatch({
          type: SET_UPDATING,
          status: false,
          sender: isUpdate ? "editing" : "creating"
        });
        console.error(error);
      });
  };
}

// export function addTags(person: *, isUpdate?: boolean = false): DispatchType {
//   if (person.tags && person.tags.length > 0) {
//     let formData = new FormData();
//     formData.append("person_id", person.uid);
//     formData.append("tag_names", JSON.stringify(person.tags));

//     return (dispatch: DispatchType) => {
//       dispatch({
//         type: SET_UPDATING,
//         status: true,
//         sender: isUpdate ? "editing" : "creating"
//       });
//       fetch(face_root + "/api/v2/tags", postInit(formData))
//         .then((res: Response): Promise<JSON> => {
//           return res.json();
//         })
//         .then((json: JSON): Function => {
//           dispatch({
//             type: SET_TAGS,
//             tags: json.tags,
//             personUid: person.uid
//           });
//           dispatch({
//             type: SET_UPDATING,
//             status: false,
//             sender: isUpdate ? "editing" : "creating"
//           });
//           //console.log(json.tags + " added");
//         })
//         .catch((reason: *) => {
//           dispatch({
//             type: SET_UPDATING,
//             status: false,
//             sender: isUpdate ? "editing" : "creating"
//           });
//           console.error(reason);
//         });
//     };
//   } else {
//     return (dispatch: DispatchType) => {
//       console.log("no tag added");
//     };
//   }
// }

export function dbAddPerson(
  person: PersonInputModel,
  callBack?: Function,
  failBack?: Function
): DispatchType {
  // let formData = new FormData();
  // formData.append("name", person.name);

  return (dispatch: DispatchType, getState: StateType) => {
    dispatch({ type: SET_UPDATING, status: true, sender: "creating" });
    fetch(face_root + "/api/v2/people", postBody(person))
      .then(handleResponse)
      .then(
        (person: PersonType) => {
          // dispatch(enrolMultiple(person));
          // dispatch(addTags(person));
          dispatch({ type: SET_UPDATING, status: false, sender: "creating" });
          dispatch(addPerson(person));
          setTimeout(function () {
            if (getState().v3account.db.errors.form) {
              failBack && failBack(getState().v3account.db.errors.form);
            } else {
              callBack && callBack();
            }
          }, 500);
        },
        (error: *) => {
          dispatch({ type: SET_UPDATING, status: false, sender: "creating" });
          failBack && failBack(error);
        }
      );
  };
}

export function updatePerson(
  person: PersonInputModel,
  callBack?: Function,
  failBack?: Function
): DispatchType {
  // let formData = new FormData();
  // formData.append("name", person.name);

  return (dispatch: DispatchType, getState: StateType) => {
    dispatch({ type: SET_UPDATING, status: true, sender: "editing" });
    fetch(face_root + "/api/v2/people/" + person.uid, putBody(person))
      .then(handleResponse)
      .then(
        (person: PersonType) => {
          dispatch({ type: SET_UPDATING, status: false, sender: "editing" });
          dispatch(addPerson(person));

          setTimeout(function () {
            if (getState().v3account.db.errors.form) {
              failBack && failBack(getState().v3account.db.errors.form);
            } else {
              callBack && callBack();
            }
          }, 500);
        },
        (error: *) => {
          dispatch({ type: SET_UPDATING, status: false, sender: "editing" });
          failBack && failBack(error);
        }
      );
  };
}

export function deleteTags(
  personUid: string,
  tags: Array<string>,
  isUpdate?: boolean = false
): DispatchType {
  if (tags.length > 0) {
    let formData = new FormData();
    formData.append("person_id", personUid);
    formData.append("tag_names", JSON.stringify(tags));
    return (dispatch: DispatchType) => {
      dispatch({
        type: SET_UPDATING,
        status: true,
        sender: isUpdate ? "editing" : "creating"
      });
      fetch(face_root + "/api/v2/tags", deleteInit(formData))
        .then((res: Response): Promise<JSON> => res.json())
        .then((json: JSON) => {
          dispatch({ type: SET_TAGS, tags: json.tags, personUid: personUid });
          dispatch({
            type: SET_UPDATING,
            status: false,
            sender: isUpdate ? "editing" : "creating"
          });
        })
        .catch((error: *) => {
          dispatch({
            type: SET_UPDATING,
            status: false,
            sender: isUpdate ? "editing" : "creating"
          });
          console.error(error);
        });
    };
  } else {
    return (dispatch: DispatchType) => {
      console.log("no tag deleted");
    };
  }
}

export function deletePerson(
  personUid: string,
  callBack?: Function,
  failBack?: Function
): DispatchType {
  return (dispatch: DispatchType) => {
    dispatch({ type: SET_UPDATING, status: true, sender: "editing" });
    fetch(face_root + "/api/v2/people/" + personUid, deleteInit())
      .then((res: Response) => {
        dispatch({ type: DELETE_PERSON, uid: personUid });
        dispatch({ type: SET_UPDATING, status: false, sender: "editing" });
        callBack && callBack();
      })
      .catch((error: *) => {
        dispatch({ type: SET_UPDATING, status: false, sender: "editing" });
        failBack && failBack(error.message);
      });
  };
}

function addPerson(person: PersonType): DispatchType {
  return (dispatch: DispatchType) => {
    dispatch({ type: ADD_PERSON, person: person });
    setTimeout(function () {
      dispatch(getFaceFromUid(person.uid));
      dispatch({
        type: SET_EMPTY_ENROLMENTS,
        personUid: person.uid,
        setNull: true
      });
    }, 500); //dirty fix, need a proper way to fix it
  };
}

export const setPeopleFormError = (error: string | null): * => ({
  type: SET_PEOPLE_FORM_ERROR,
  error: error
});
